import { localeSearchUrl } from '@/components/helpers/utils'

export function SearchPageLink({ children, query, className, url }) {
  const link = query ? localeSearchUrl(query) : url

  if (!link) return null
  return (
    <a href={link} className={className} aria-label={query}>
      {children}
    </a>
  )
}
